import styled from 'styled-components'

export const LoadingComponent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`
